package ru.villawonka.app.data.repository

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.common.utils.map
import ru.villawonka.app.data.entity.request.toRequest
import ru.villawonka.app.data.entity.response.toDomain
import ru.villawonka.app.data.utils.networkRequest
import ru.villawonka.app.data.source.UserApi
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.UserCountryDomain
import ru.villawonka.app.domain.model.UserSettingsDomain
import ru.villawonka.app.domain.repository.UserRepository

class UserRepositoryImpl(
    private val userApi: UserApi,
    private val authRepository: AuthRepository,
) : UserRepository {

    private var cachedUserCountry: UserCountryDomain? = null

    override fun isNewUser(): Boolean = authRepository.isNewUser

    override suspend fun getCountry(): Either<NetworkFailure, UserCountryDomain> =
        cachedUserCountry?.let { Either.Right(it) } ?: networkRequest {
            userApi.getCountry()
        }.map { response ->
            response.toDomain().also {
                cachedUserCountry = it
            }
        }

    override suspend fun getSettings(): Either<NetworkFailure, UserSettingsDomain> =
        networkRequest { userApi.getSettings() }.map { it.toDomain() }

    override suspend fun updateSettings(
        userSettings: UserSettingsDomain
    ): Either<NetworkFailure, Unit> =
        networkRequest { userApi.updateSettings(userSettings.toRequest()) }
}